//dependencies
import React from "react";

import { AdminTitle } from "../../../../../../../components/Admin";
import Spacer from "../../../../../../../components/Spacer";
import Text from "../../../../../../../components/Text";

//hooks
import useNavigate from "../../../../../../../hooks/useNavigate";
import useToast from "../../../../../../../hooks/useToast";

//services
import { updateCohort } from "../../../../../../../api/services";

//components
import DynamicEmployeesQueryBuilder from "../../../../Components/DynamicEmployeesQueryBuilder";
import { DynamicCohortQuery } from "../../../../Components/DynamicEmployeesQueryBuilder/DynamicEmployeesUtils";
// css
import css from "./DynamicEmployees.module.scss";

declare interface DynamicEmployeesEditProps {
	backUrl: string;
	cohort: {
		_id: string;
		name: string;
		query?: DynamicCohortQuery;
	};
}

const DynamicEmployeesEdit = ({ backUrl, cohort }: DynamicEmployeesEditProps) => {
	const toast = useToast();
	const navigate = useNavigate();

	return (
		<>
			<AdminTitle includeSpacer={false}>Employee Cohorts</AdminTitle>
			<Spacer height={4} />
			<div className={css.header}>
				<Text className={css.name} size="paragraph-1" weight="semi-bold" color="neutral-9">
					Edit Conditions of {cohort.name}
				</Text>
			</div>
			<Spacer height={2} />
			<DynamicEmployeesQueryBuilder
				isEdit
				goBack={() => navigate(backUrl)}
				onSave={async (updatedCohortQuery: DynamicCohortQuery) => {
					try {
						await updateCohort(cohort._id, {
							query: updatedCohortQuery,
						});
						toast(`Successfully updated cohort`, { type: "success", size: "large" });
						navigate(`/administration/engagement/cohorts`);
					} catch (e) {
						toast("Unable to add employees to cohort.", { type: "error", size: "large" });
					}
				}}
				existingDynamicEmployeesQuery={cohort.query}
			/>
		</>
	);
};

export default DynamicEmployeesEdit;
